import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"
import { SCHEDULE_TYPE_FIELDS } from "authoring/routes/controller/get-project-schedules"

export const getComparePublishedSchedule = api(async function schedule(id, version = "no_v") {
    if (!id) return null
    return query(
        gql`
            query getSchedule($code: String!, $version: String) {
                schedule(code: $code, version: $version) {
                    ${SCHEDULE_TYPE_FIELDS}
                }
            }
        `,
        { code: id, version },
        {
            returns: "schedule",
            fetchPolicy: "network-only",
            transform: (result) => {
                const legislation = result?.legislation ?? []
                const updatedLegislation = legislation.map(({ ScheduleLegislationID }) =>
                    parseInt(ScheduleLegislationID)
                )
                return {
                    ...result,
                    legislation: updatedLegislation,
                }
            },
        }
    )
})
